import { LightHeading } from '@components/buzzkuri/shared/uiParts/heading/LightHeading'
import { ProgramLabel } from '@type/buzzkuri/programs'
import { cloudfrontPath } from '@utils/image'
import React from 'react'
import { RecommendGenreCards } from './GenreCards'
import { RecommendTagList } from './TagList'

const BASE_IMAGE_PATH = `${cloudfrontPath}/programs/icons/programs/`
const STATIC_RECOMEND_ITEM = [
  { name: '焚き火', imageFileName: 'bonfire.svg' },
  { name: 'マインドフルネス', imageFileName: 'mindfulness.svg' },
  { name: 'おとなの図工', imageFileName: 'adult_arts.svg' },
  { name: 'プレゼンテーション', imageFileName: 'presentation.svg' },
]

const RECOMMEND_GENRE_CARDS = STATIC_RECOMEND_ITEM.map(
  ({ name, imageFileName }) => ({
    image: {
      src: `${BASE_IMAGE_PATH}${imageFileName}`,
      alt: `${name}プログラムのアイコン`,
      width: 30,
      height: 30,
    },
    text: name,
  })
)

type Props = {
  recommendTags: ProgramLabel[]
}

export const RecommendGenre = ({ recommendTags }: Props): JSX.Element => {
  return (
    <div>
      <LightHeading text="おすすめのジャンル・タグ" />
      <div className="mt-[5.3vw] lg:mt-[1.4vw]">
        <RecommendGenreCards {...RECOMMEND_GENRE_CARDS} />
      </div>
      <div className="mt-[2.7vw] lg:mt-[2.1vw]">
        <RecommendTagList {...{ recommendTags }} />
      </div>
    </div>
  )
}
